/** @jsx jsx */

import { Fragment } from 'react';

import { Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import Link from 'app/common/components/Link';
import { ZAPIER_APP_BASE_URL } from 'app/common/constants';
import { getAppUrl } from 'app/developer-v3/utils';

import ExploreEmbeddingTodo from './ExploreEmbeddingTodo';
import TodosSimple from './TodosSimple';

const Styles = {
  root: css`
    margin-bottom: 20px;
  `,
};

type Props = {
  integrationId: number;
};

export default function TodosBeta({ integrationId }: Props) {
  return (
    <div css={Styles.root}>
      <Text margin="0px 0px 20px" tag="p" type="Body1">
        After passing review your integration will be available in the Zapier
        app directory and you’ll be able start working on Zap templates to share
        use cases with your users, and publish help content.
      </Text>
      <TodosSimple
        description={
          "Watch your email. If our team finds anything that needs tweaking we'll let you know."
        }
        icon="actionEmailFill"
      />
      <TodosSimple
        description={<ExploreEmbeddingTodo integrationId={integrationId} />}
        icon="navIntegrationsFill"
      />
      <TodosSimple
        description={
          <Fragment>
            Check out{' '}
            <Link
              href={`${ZAPIER_APP_BASE_URL}/platform/partner-program`}
              target="_blank"
            >
              partner program benefits
            </Link>{' '}
            to see what’s coming up next
          </Fragment>
        }
        icon="ratingStarFill"
      />
      <TodosSimple
        description={
          <Fragment>
            <Link href={`${getAppUrl(integrationId)}/sharing`}>
              Invite users
            </Link>{' '}
            to start using your integration
          </Fragment>
        }
        icon="formAddSquare"
      />
    </div>
  );
}
